import axios from '@/libs/axios';

// Mapeia a chave de tamanho usada na grade (itemXxx) para o campo com o cdn_tamanho (itemTamanhoXxx)
const GRADE_TAMANHO_PREFIX = 'itemTamanho';

let tamanhosPromise = null;

/**
 * Carrega (uma única vez) os tamanhos cadastrados em sls_tamanho.
 * Retorna um objeto { [cdn_tamanho]: des_tamanho }.
 */
export function carregarTamanhos() {
  if (!tamanhosPromise) {
    tamanhosPromise = axios.get('/tamanhos?perPage=10000')
      .then((response) => (response.data?.data || []).reduce((acc, t) => {
        acc[String(t.cdn_tamanho)] = t.des_tamanho;
        return acc;
      }, {}))
      .catch((error) => {
        console.error('Erro ao carregar tamanhos: ', error);
        tamanhosPromise = null;
        return {};
      });
  }
  return tamanhosPromise;
}

/**
 * Descrição exibida para um tamanho da grade (ex.: 'Outros' -> '33 a 37').
 * Se não houver descrição cadastrada, mantém o nome da chave.
 * Apenas visual: a chave original continua sendo usada para localizar o SKU.
 */
export function descricaoTamanhoGrade(gradeColor, size, tamanhos) {
  const cdnTamanho = gradeColor?.[`${GRADE_TAMANHO_PREFIX}${size}`];
  return (cdnTamanho && tamanhos?.[String(cdnTamanho)]) || size;
}
